import React, { useState, useEffect, useRef } from "react"
import { Galleria } from 'primereact/galleria'
import { CheckboxField } from "../../../helpers"
import { RadioButton } from "primereact/radiobutton"

const MaterialImageGalleria = (props) => {
    const { materialImages, thumbnailImageId } = props
    const [activeIndex, setActiveIndex] = useState(null)

    const galleria = useRef(null)

    const itemTemplate = (item) => {
        return <img src={item.dataURI} alt={item.fileName} style={{ width: '100%', display: 'block' }} />
    }

    const thumbnailTemplate = (item) => {
        return <img src={item.dataURI} alt={item.fileName} style={{ display: 'block' }} />
    }

    const removeImage = (removedImageId) => {
        props.handleRemoveMaterialImage(removedImageId)
        if(removedImageId === thumbnailImageId){
            props.setThumbnailImageId(null)
        }
        setActiveIndex(0)
    }

    const handleOnClickImage = (imageIndex) => {
        setActiveIndex(imageIndex)
        galleria.current.show()
    }

    return (
        <div className="">
            <Galleria ref={galleria} value={materialImages} numVisible={3}
                activeIndex={activeIndex} onItemChange={(e) => setActiveIndex(e.index)}
                circular fullScreen showItemNavigators showThumbnails={false} item={itemTemplate} thumbnail={thumbnailTemplate}
            />
            <div className="main-img-container">
                {
                    materialImages && materialImages.map((image, index) => {
                        let isThumbnailImage = image.imageId === thumbnailImageId
                        let imgEl = (
                            <div className="image-container" style={{ position: 'relative' }}>
                                <img src={image.dataURI}
                                    className="prod-image"
                                    style={{ cursor: 'pointer', width: '150px', height: '150px', border: isThumbnailImage ? '2px solid #00baaa' : '1px solid #ccc', boxShadow: isThumbnailImage ? '0 0 10px rgba(0, 255, 0, 0.5)' : 'none', borderRadius: "3px", objectFit: 'cover' }}
                                    onClick={() => handleOnClickImage(index)}
                                />
                                {/* <CheckboxField className="thumbnail-checkbox" label="Set as thumbnail" onChange={(e) => props.setThumbnailImageId(image.imageId)} checked={thumbnailImageId === image.imageId} /> */}
                                <div className="flex">
                                    <RadioButton className="mr-1" inputId={`thumbnail-${image.imageId}`} name="thumbnail" value={image.imageId} onChange={(e) => props.setThumbnailImageId(e.value)} checked={thumbnailImageId === image.imageId} />
                                    <label htmlFor={`thumbnail-${image.imageId}`} className="">Set as thumbnail</label>    
                                </div>
                                <i className="pi pi-times prod-remove-icon" onClick={() => removeImage(image.imageId)}></i>
                            </div>
                        )
                        return (
                            <div key={index} className='flex p-grid w-2 mt-2 prod-image-container' style={{ maxWidth: '400px', maxHeight: '400px' }}>
                                {imgEl}
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default MaterialImageGalleria